import * as React from "react";
const SvgCheckCircle = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.75 12a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0ZM12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25Zm4.957 8.11a.75.75 0 0 0-1.121-.996L11.02 13.78l-2.104-2.03a.75.75 0 1 0-1.041 1.08l2.667 2.572a.75.75 0 0 0 1.08-.042l5.334-6Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgCheckCircle;
